import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PortalUsersRepository } from '../repositories/portal_users_repository/portal_users_repository';

export const fetchPortalUsers = createAsyncThunk('portal/users/fetch', async (_, { getState }) => {
  try {
    const userState = getState().user;

    const portfolioId = userState.user.pid;

    if (portfolioId) {
      const portalUsers = await PortalUsersRepository.getPortalUsers(portfolioId);
      return portalUsers;
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error fetching portal users:', error);

    throw error;
  }
});

const initialState = {
  portalUsers: [],
  isLoading: false,
  error: null,
};

const portalUsersSlice = createSlice({
  name: 'portalUsers',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPortalUsers.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchPortalUsers.fulfilled, (state, action) => {
      state.portalUsers = action?.payload ?? [];
      state.isLoading = false;
      state.error = null;
    });
    builder.addCase(fetchPortalUsers.rejected, (state, action) => {
      console.log(action.error.message ?? 'Something went wrong.');
      state.chargersStatus = [];
      state.isLoading = false;
      state.error = action.error.message ?? 'Something went wrong.';
    });
  },
});

export default portalUsersSlice.reducer;
